export default "__VITE_ASSET__5d348930__"